import { render, staticRenderFns } from "./SaveConfirm.vue?vue&type=template&id=da0832c8&scoped=true"
import script from "./SaveConfirm.vue?vue&type=script&lang=js"
export * from "./SaveConfirm.vue?vue&type=script&lang=js"
import style0 from "./SaveConfirm.vue?vue&type=style&index=0&id=da0832c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0832c8",
  null
  
)

export default component.exports